<ng-container *ngIf="profileField$ | async as profileField">
    <ng-container *ngFor="let typedValue of typedLabeledValues$ | async">
        <ng-container *ngIf="typedValue.value.length > 0">
            <dt class="sh-description-list__term" [id]="profileField.FieldDefinition.DottedKey + '.' + typedValue.type">
                <sh-field-label [label]="typeTranslations.get(typedValue.type)" [labelIcons]="labelIcons"></sh-field-label>
            </dt>
            <dd class="sh-description-list__details" *ngIf="typeFieldDefinitions.get(typedValue.type) as typeFieldDef">
                <ng-container
                    *ngTemplateOutlet="
                        canSearchOnClick(typeFieldDef) ? searchableData : nonSearchableData;
                        context: { values: typedValue.value, fieldDefinition: typeFieldDef }
                    "
                >
                </ng-container>
            </dd>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #searchableData let-values="values" let-fieldDefinition="fieldDefinition">
    <span *ngFor="let labeledValue of values; let index = index">
        <a class="sh-link" [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(fieldDefinition, labeledValue.value)">{{
            labeledValue.label
        }}</a>
        <ng-container *ngIf="index < values.length - 1">, </ng-container>
    </span>
</ng-template>

<ng-template #nonSearchableData let-values="values">
    <span *ngFor="let labeledValue of values; let index = index">
        {{ labeledValue.label }}
        <ng-container *ngIf="index < values.length - 1">, </ng-container>
    </span>
</ng-template>
